var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSou7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5015 0 0 1.14938 -450.654 -595.069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.399,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.704,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.672,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08 609.923v-71.438",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#b93c3c",
      strokeWidth: 29.07647514,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.673,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.897,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.352,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.97 537.21v22.661m0 28.679v21.47",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.468 574.027h1.008",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5015 0 0 1.14938 -450.654 -328.092)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.399,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.704,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.672,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08 609.923v-71.438",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 29.07647514,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.673,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.897,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.352,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.97 537.21v22.661m0 28.679v21.47",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.468 574.027h1.008",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5015 0 0 1.14938 -555.323 -328.092)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.399,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.704,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.672,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08 609.923v-71.438",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 29.07647514,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.673,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.897,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.352,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.97 537.21v22.661m0 28.679v21.47",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.468 574.027h1.008",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5015 0 0 1.14938 -346.89 -328.092)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.399,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.704,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.672,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08 609.923v-71.438",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 29.07647514,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.673,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.897,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.352,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.97 537.21v22.661m0 28.679v21.47",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.468 574.027h1.008",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5015 0 0 1.14938 -450.654 -460.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.399,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.704,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.672,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08 609.923v-71.438",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 29.07647514,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.673,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.897,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.352,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.97 537.21v22.661m0 28.679v21.47",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332146,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.468 574.027h1.008",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332146,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5015 0 0 1.14938 -555.323 -460.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.399,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.704,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.672,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08 609.923v-71.438",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 29.07647514,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.673,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.897,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.352,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.97 537.21v22.661m0 28.679v21.47",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.468 574.027h1.008",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5015 0 0 1.14938 -346.89 -460.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.399,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.704,
    cy: 540.31,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.672,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08 609.923v-71.438",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 29.07647514,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.673,
    cy: 612.173,
    r: 13.404,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.897,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.352,
    cy: 574.399,
    r: 16.323,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.97 537.21v22.661m0 28.679v21.47",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.468 574.027h1.008",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.37332153,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSou7);
export default __webpack_public_path__ + "static/media/Sou7.eafa8ca3bbc42106a97ae77ca3e936e6.svg";
export { ForwardRef as ReactComponent };